import React, { useState,useEffect } from "react";
import { 
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  useTheme,
  IconButton,
  Tooltip,
  Box
} from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import {
  Dashboard as DashboardIcon,
  AccountCircle as AccountsIcon,
  Dns as ProxyIcon,
  Message as MessageIcon,
  Schedule as ScheduleIcon,
  Archive as ArchiveIcon,
  VerifiedUser as VUser,
  LocalActivity as MsgIcon,
  TaskSharp as TaskIcon,
  ChevronLeft,
  ChevronRight,
  FlutterDash,
  

  Group, // manage_users
  Archive, // archive_content
  Send, // send_messages
  Schedule, // schedule_posts
  Assessment, // view_reports
  Telegram, // telegram_accounts
  Message, // manage_messages
  Public, // manage_proxy
  Campaign, // campaigns
  DataThresholding, // scraper
  ListAlt, // logger
  PeopleAlt // members_scraper
} from "@mui/icons-material";
import { Typography } from '@mui/material';
import eventBus from "./Eventbus";
import ApiService from '../API/Requesthandler'

const drawerWidthExpanded = 260;
const drawerWidthCollapsed = 80;

function Sidebar() {
  const theme = useTheme();
  const { pathname } = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [permissionsData,setPermissionsData] = useState([])

  const user_data = JSON.parse(localStorage.getItem('user-data'))
  
  useEffect(()=>{
    ApiService.get('/api/users/get_permission?id='+user_data['id'])
    .then(res =>{
      // console.log(res)
      setPermissionsData(eval(res.data))
      
    }).catch(err =>{
      console.log(err)
    })
    },[])


  function checkPermission(permission){
    var found = false;
    permissionsData.forEach((element) => {
      // console.log(index)
      if (element === permission){
        found = true;
      }
    });

    return found;
  }


  const menuItems = [    

  ];




  if (checkPermission('view_reports')){menuItems.push({ text: "Dashboard", path: "/dashboard", icon: <Assessment /> })}
   if (checkPermission('manage_users')){menuItems.push({ text: "User Management", path: "/user-management", icon: <Group /> })}
   if (checkPermission('telegram_accounts')){menuItems.push({ text: "Telegram Accounts", path: "/telegram-accounts", icon: <Telegram /> })}
   if (checkPermission('manage_proxy')){menuItems.push({ text: "Proxy Management", path: "/proxy-management", icon: <Public /> })}
   if (checkPermission('send_messages')){menuItems.push({ text: "Message Creation", path: "/message-creation", icon: <Send /> })}
   if (checkPermission('campaigns')){menuItems.push({ text: "Campaigns", path:"/campaigns", icon: <Campaign/> })}
   if (checkPermission('manage_messages')){menuItems.push({ text: "Message Activity", path: "/message-management", icon: <Message /> })}
   if (checkPermission('logger')){menuItems.push({ text: "Message Logs", path: "/logger", icon: <Telegram /> })}
   if (checkPermission('schedule_posts')){menuItems.push({ text: "Task Scheduler", path: "/task-scheduler", icon: <Schedule /> })}  
   if (checkPermission('archive_content')){menuItems.push({ text: "Archive & Filtering", path: "/archive-filtering", icon: <Archive /> })}
   if (checkPermission('scraper')){menuItems.push({ text: "Message Forwarder", path: "/scraper", icon: <DataThresholding /> })}
   if (checkPermission('members_scraper')){menuItems.push({ text: "Members Scraper", path: "/members_scraper", icon: <PeopleAlt /> })}
   
   


  const toggleSidebar = () => {

        const newState = !isCollapsed;
        setIsCollapsed(newState);
        eventBus.dispatchEvent(new CustomEvent("sidebarToggle", { detail: newState }));
  }

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        width: isCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
        flexShrink: 0,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        '& .MuiDrawer-paper': {
          width: isCollapsed ? drawerWidthCollapsed : drawerWidthExpanded,
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
          borderRight: 'none',
          boxShadow: theme.shadows[3],
        },
      }}
    >
      {/* Brand Section */}
      <Toolbar sx={{ 
        minHeight: '80px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: isCollapsed ? 'center' : 'flex-start',
        px: isCollapsed ? 0 : 2,
        // borderBottom: `1px solid ${theme.palette.divider}`
      }}>
        {!isCollapsed ? (
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 700,
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-0.5px'
            }}
          >
            Telegram Poster
          </Typography>
        ) : (
          <Box sx={{
            width: 32,
            height: 32,
            background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
            borderRadius: '8px',
            textAlign:'center',
            color:'white',
            justifyContent:'center',
            alignItems:'center'
          }} >
            <Typography variant="h6" >TP</Typography>
          </Box>
        )}
      </Toolbar>

      {/* Navigation Items */}
      <List sx={{ px: 1, pt: 2 }}>
        {menuItems.map((item) => {
          const isActive = pathname === item.path;
          
          return (
            <Tooltip 
              key={item.text} 
              title={isCollapsed ? item.text : ''} 
              placement="right"
              arrow
            >
              <ListItem 
                button 
                component={Link} 
                to={item.path}
                sx={{
                  mb: 0.5,
                  borderRadius: '12px',
                  borderTopRightRadius:"0",
                  borderBottomRightRadius:"0",
                  transition: 'all 0.2s ease',
                  px: 2,
                  mx: 1,
                  minHeight: '48px',
                  '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                  },
                  ...(isActive && {
                    backgroundColor: `${theme.palette.primary.main}15`,
                    color: theme.palette.primary.main,
                    '& .MuiListItemIcon-root': {
                      color: theme.palette.primary.main
                    }
                  })
                }}
              >
                <ListItemIcon sx={{ 
                  minWidth: '40px',
                  color: isActive ? theme.palette.primary.main : theme.palette.text.secondary
                }}>
                  {item.icon}
                </ListItemIcon>
                {!isCollapsed && (
                  <ListItemText 
                    primary={item.text} 
                    primaryTypographyProps={{ 
                      variant: 'body2',
                      fontWeight: 500,
                      sx: {
                        fontSize: '0.875rem',
                        color: isActive ? theme.palette.primary.main : theme.palette.text.primary
                      }
                    }}
                  />
                )}
              </ListItem>
            </Tooltip>
          )}
        )}
      </List>

      {/* Collapse Button */}
      <Box sx={{ 
        mt: 'auto', 
        p: 2,
        display: 'flex',
        justifyContent: isCollapsed ? 'center' : 'flex-end'
      }}>
        <IconButton
          onClick={toggleSidebar}
          sx={{
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            }
          }}
        >
          {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
        </IconButton>
      </Box>
    </Drawer>
  );
}

export default Sidebar;